import React, { FC } from "react";
import styled from "styled-components";

const CashCard: FC = () => {
  return (
    <Root>
      <Title>現金決済でお支払い</Title>
      <Content>
        <Attention>※お支払いは窓口にて現金でお支払いいただきます。</Attention>
      </Content>
    </Root>
  )
}
export default CashCard;

const Root = styled.div`
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  padding: 16px;
`;

const Title = styled.div`
  font-size: 16px;
  margin-bottom: 16px;
`;

const Content = styled.div`
  margin-top: 16px;
`;

const Attention = styled.div`
  font-size: 14px;
  line-height: 1.428em;
`;
